// Observe meta bar to shrink logo when it's scrolled past
const metaBar = document.querySelector('.js-block-meta--1');
const header = document.querySelector('.js-block-header');
if (header) {
  new IntersectionObserver(metBarObserver).observe(metaBar);
}

function metBarObserver(entries) {
  if (!entries[0].isIntersecting) {
    header.classList.add('is-stuck');
  } else {
    header.classList.remove('is-stuck');
  }
}